/* eslint-disable */
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Importar CSS do Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
// Importar JS do Bootstrap
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Importar CSS próprio
import './assets/css/style.css';
// Importar CSS Animate
import './assets/lib/animate/animate.min.css';

// Importar jQuery
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// Importar Instafeed e WOW.js corretamente
import Instafeed from './assets/js/instafeed.min.js';
import { WOW } from 'wowjs';

// Definir Instafeed e WOW.js como variáveis globais
window.Instafeed = Instafeed;
window.WOW = WOW;

const app = createApp(App);
app.use(router);

// Inicializar WOW.js após a montagem do app
app.mount('#app');
new WOW().init();

// Inicializar Instafeed após a montagem do app
document.addEventListener('DOMContentLoaded', function () {
    var feed = new Instafeed({
        accessToken: 'IGQWROOHJHZAEUzQ1VqaFFuNWNCMWJSUUtXNUVOZA0lKVjZASVG5IYVRYYVpPSlhoZAVE3dDcwZATloaWRpb2RUVFI5Wkl4OWlDS1ZALdmlXWExjOTA2ZAlJ0d0U0LXVXNmJ4b21PTDZAvTHFjb20tbFA0T3E0ZAnhPcjh2aWMZD',
        limit: 8,
        template: '<div class="col-sm-12 col-md-3 col-lg-3"><a href="{{link}}"><img title="{{caption}}" class="w-100 mb-4" src="{{image}}" /></a></div>',
    });
    feed.run();
});
/* eslint-enable */
